import React from 'react'
import { styled } from '@mui/material/styles'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import palette from 'core-system/Themes/palette'
import { TabsProps } from '@mui/material'

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${palette.grey.grey300}`,
  width: '100%',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
    alignItems: 'flex-start',
  },
}))

const TabsContainer = styled(Tabs)(() => ({
  '& .MuiTabs-indicator': {
    backgroundColor: palette.secondary.purple600,
    height: '3px',
  },
}))

const RightComponentContainer = styled('div')(({ theme }) => ({
  marginBottom: '0.25rem',

  [theme.breakpoints.down('md')]: {
    marginBottom: '0.5rem',
  },
}))

const TabItem = styled(Tab)(() => ({
  fontFamily: 'PolySans',
  textTransform: 'none',
  fontSize: '1rem',
  fontWeight: 600,
  color: palette.text.primary,
  '&.Mui-selected': {
    color: palette.text.primary,
  },
  '&:hover': {
    color: palette.secondary.purple700,
  },
  '&.MuiTab-root': {
    marginRight: '1.25rem',
    padding: '1.25rem 0',
  },
}))

interface TabsPropsPrimary extends TabsProps {
  tabs: {
    label: string
    value: number
  }[]
  rightComponent?: React.ReactNode
}

const TabsPrimary = React.memo((props: TabsPropsPrimary) => {
  const { tabs, rightComponent, ...rest } = props

  return (
    <Container>
      <TabsContainer {...rest}>
        {tabs.map((tab) => (
          <TabItem key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </TabsContainer>
      <RightComponentContainer>{rightComponent}</RightComponentContainer>
    </Container>
  )
})

export default TabsPrimary
